/** Matches react-chessboard default move animation duration. */
export const REVIEW_MOVE_ANIMATION_MS = 300;

/** Fast (0.5 s) autoplay step — baseline for scaling mistake-sequence timing. */
export const WATCH_AUTOPLAY_FAST_STEP_MS = 500;

/** Original wrong-move hold before refutation at fast autoplay. */
const WATCH_AUTOPLAY_WRONG_HOLD_MS = 340;

/** Show the move-quality dot on a mistake before wrong/refutation feedback. */
const WATCH_AUTOPLAY_PRE_REFUTATION_BADGE_MS = 400;

/** Hold the refutation on the board before showing the best-move arrow. */
export const WATCH_AUTOPLAY_REFUTATION_MS = 1500;

/** Hold the best-move arrow visible before resuming watch auto-play. */
export const WATCH_AUTOPLAY_MISTAKE_ANSWER_MS = 3000;

/** Original refutation move animation at fast autoplay (miss sequence). */
const WATCH_AUTOPLAY_MISS_ANIMATION_MS = 220;

function scaleWatchAutoplayMs(
  baselineMs: number,
  autoplayStepMs: number,
): number {
  return Math.round(
    baselineMs * (autoplayStepMs / WATCH_AUTOPLAY_FAST_STEP_MS),
  );
}

/** Hold the wrong move before playing refutation; scales with autoplay pace. */
export function watchAutoplayWrongHoldMs(autoplayStepMs: number): number {
  return scaleWatchAutoplayMs(WATCH_AUTOPLAY_WRONG_HOLD_MS, autoplayStepMs);
}

/** Hold the quality dot on a mistake before starting refutation feedback. */
export function watchAutoplayPreRefutationBadgeMs(autoplayStepMs: number): number {
  return scaleWatchAutoplayMs(WATCH_AUTOPLAY_PRE_REFUTATION_BADGE_MS, autoplayStepMs);
}

/** Hold the refutation on the board before showing the best-move arrow. */
export function watchAutoplayRefutationMs(autoplayStepMs: number): number {
  return scaleWatchAutoplayMs(WATCH_AUTOPLAY_REFUTATION_MS, autoplayStepMs);
}

/** Hold the best-move arrow before resuming watch auto-play. */
export function watchAutoplayMistakeAnswerMs(autoplayStepMs: number): number {
  return scaleWatchAutoplayMs(
    WATCH_AUTOPLAY_MISTAKE_ANSWER_MS,
    autoplayStepMs,
  );
}

/** Refutation move animation during watch autoplay. */
export function watchAutoplayMissAnimationDuration(
  animating: boolean,
  autoplayStepMs: number,
): number {
  return animating
    ? scaleWatchAutoplayMs(WATCH_AUTOPLAY_MISS_ANIMATION_MS, autoplayStepMs)
    : 0;
}

/** Pause at the loop boundary before restarting preview autoplay. */
export const REVIEW_PREVIEW_LOOP_PAUSE_MS = 900;
